import React, { useState } from "react";
import { db } from "../../firebase";

import {
  collection,
  getDocs,
  query,
  where,
  limit,
} from "firebase/firestore";

import "./PrintApplication.css";
import Navbar from "../inc/Navbar";

function PrintApplication() {
  const [mobile, setMobile] = useState("");
  const [dob, setDob] = useState("");
  const [application, setApplication] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  // Search Application
  const handleSearch = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      setApplication(null);
      setSearched(false);

      const q = query(
        collection(db, "teacher_application_data"),
        where("contactNo", "==", mobile),
        where("dob", "==", dob),
        limit(1)
      );

      const snapshot = await getDocs(q);

      setSearched(true);

      if (!snapshot.empty) {
        const docData = snapshot.docs[0];

        setApplication({
          id: docData.id,
          ...docData.data(),
        });
      } else {
        alert("No Application Found! Please check your details.");
      }

    } catch (error) {
      console.error(error);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Print Application
  const handlePrint = () => {
    window.print();
  };

  return (
    <>
   
    <div className="print-page">

      {/* Search Section */}

      <div className="container search-section no-print">
  
          <a href='StudentFrom'>
           <p><button className='apply'>New Apply </button></p>
           </a>
           <hr/>
        <div className="card shadow p-2">

          <h3 style={{color:"#7E1717"}} className="text-center mt-2">
            Print Your Application
          </h3>

          <p style={{color:"#7E1717"}}className="text-center text-muted">
            Enter your registered mobile number and date of birth.
          </p>

          <form onSubmit={handleSearch}>

            <input
              type="tel"
              className="form-control mt-3"
              placeholder="Enter Registered Mobile Number"
              pattern="[0-9]{10}"
              maxLength="10"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              required
            />

            <input
              type="date"
              className="form-control mt-3"
              value={dob}
              onChange={(e) => setDob(e.target.value)}
              required
            />

            <button
              type="submit" 
              className="btn btn-danger w-100 mt-3"
              disabled={loading}
            >
              {loading ? "Searching..." : "SEARCH APPLICATION"}
            </button>

          </form>

        </div>
      </div>

      {/* Application Details */}

      {application && (

        <div className="container application-container">

          <div className="application-sheet">

            {/* Header */}

            <div className="application-header">

              <h2 style={{color:"#7E1717"}}>STUDENT APPLICATION FORM</h2>

              <h5 style={{color:"#7E1717"}}>APPLICATION DETAILS</h5>

              <p style={{color:"#012671"}}>
                Application ID: {application.id}
              </p>

            </div>

            {/* Photo */}

            <div className="photo-section">

              {application.photoURL && (
                <img
                  src={application.photoURL}
                  alt="Applicant"
                  className="applicant-photo"
                />
              )}

            </div>

            {/* Personal Information */}

            <h5 className="section-title">
              PERSONAL DETAILS
            </h5>

            <table className="application-table">
              <tbody>

                <tr>
                  <th>Name of Applicant</th>
                  <td>{application.applicantName}</td>
                </tr>

                <tr>
                  <th>Father's Name</th>
                  <td>{application.fatherName}</td>
                </tr>

                <tr>
                  <th>Mother's Name</th>
                  <td>{application.motherName}</td>
                </tr>

                <tr>
                  <th>Guardian's Name</th>
                  <td>{application.guardianName}</td>
                </tr>

                <tr>
                  <th>Date of Birth</th>
                  <td>{application.dob}</td>
                </tr>

                <tr>
                  <th>Contact Number</th>
                  <td>{application.contactNo}</td>
                </tr>

                <tr>
                  <th>Aadhaar Number</th>
                  <td>
                    {application.aadharNo
                      ? "XXXX XXXX " + application.aadharNo.slice(-4)
                      : ""}
                  </td>
                </tr>

                <tr>
                  <th>Gender</th>
                  <td>{application.gender}</td>
                </tr>

                <tr>
                  <th>Category</th>
                  <td>{application.category}</td>
                </tr>

                <tr>
                  <th>E-mail</th>
                  <td>{application.email}</td>
                </tr>

                <tr>
                  <th>Religion</th>
                  <td>{application.religion}</td>
                </tr>

                <tr>
                  <th>Address</th>
                  <td>{application.address}</td>
                </tr>

              </tbody>
            </table>

            {/* HS Details */}

            <h5 className="section-title">
              HIGHER SECONDARY DETAILS
            </h5>

            <table className="application-table">
              <tbody>

                <tr>
                  <th>HS Board Name</th>
                  <td>{application.hsBoard}</td>
                </tr>

                <tr>
                  <th>HS Subject</th>
                  <td>{application.hsSubject}</td>
                </tr>

                <tr>
                  <th>Total Marks</th>
                  <td>{application.totalMarks}</td>
                </tr>

                <tr>
                  <th>Marks Obtained</th>
                  <td>{application.marksObtained}</td>
                </tr>

              </tbody>
            </table>

            {/* Signature */}

            <div className="signature-area">

              <div>
                {application.signatureURL && (
                  <img
                    src={application.signatureURL}
                    alt="Signature"
                    className="signature-image"
                  />
                )}

                <p>Applicant's Signature</p>
              </div>

              <div>
                <p>_____________________</p>
                <p>Authorized Signature</p>
              </div>

            </div>

            <div className="application-footer">
              <p>
                I hereby declare that all the information
                provided above is true and correct.
              </p>

              <p>
                Application Status: {application.applicationStatus}
              </p>
            </div>

          </div>

          {/* Document Links - Screen Only */}

          <div className="card p-3 mt-3 no-print">

            <h5>Uploaded Documents</h5>

            <p>
              <a href={application.photoURL} target="_blank" rel="noreferrer">
                View Photograph
              </a>
            </p>

            <p>
              <a href={application.signatureURL} target="_blank" rel="noreferrer">
                View Signature
              </a>
            </p>

            <p>
              <a href={application.aadharURL} target="_blank" rel="noreferrer">
                View Aadhaar Card
              </a>
            </p>

            <p>
              <a href={application.hsMarksheetURL} target="_blank" rel="noreferrer">
                View HS Marksheet
              </a>
            </p>

          </div>

          {/* Print Button */}

          <div className="text-center my-4 no-print">

            <button
              className="btn btn-success btn-lg px-5"
              onClick={handlePrint}
            >
              PRINT APPLICATION
            </button>

          </div>

        </div>
      )}

    </div>
    </>
  );
}

export default PrintApplication;